import type * as React from 'react';
import { putFormData } from '@Domain/Api';
import accountLogoReplaced, {
	type AccountLogoReplacedAction,
} from '@Application/Branding/AccountLogo/Actions/accountLogoReplaced';
import accountLogoReplacementFailed, {
	type AccountLogoReplacementFailedAction,
} from '@Application/Branding/AccountLogo/Actions/accountLogoReplacementFailed';
import type ReplaceAccountLogo from '@Application/Branding/AccountLogo/Commands/ReplaceAccountLogo';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../../parameters';

type Actions = AccountLogoReplacedAction | AccountLogoReplacementFailedAction;

export default (command: ReplaceAccountLogo) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			await putFormData<void>(
				`${parameters.api.host}/api/accounts/${command.accountId}/logo`,
				command.toFormData(),
			);

			const action = accountLogoReplaced({ accountId: command.accountId });
			dispatch(action);
			return action;
		} catch (error) {
			const action = accountLogoReplacementFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
